<div class="public-subscription-container">
  <div class="public-subscription-header">
    <div class="header-content">
      <div class="plan-info">
        <p class="plan-subtitle">{{ 'subscription.subtitle' | translate }}</p>
      </div>
      
      <div class="billing-toggle">
        <div class="toggle-container">
          <span class="toggle-label" [class.active]="!isYearly">{{ 'subscription.billingMonthly' | translate }}</span>
          <mat-slide-toggle color="primary" [(ngModel)]="isYearly"></mat-slide-toggle>
          <span class="toggle-label" [class.active]="isYearly">{{ 'subscription.billingYearly' | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="mobile-view" *ngIf="isMobile">
    <div class="mobile-plan-card" *ngFor="let planName of ['Basic', 'Premium']; let i = index">
      <div class="plan-header">
        <h3 class="plan-name">{{ planName | titlecase }}</h3>
      </div>
      <div class="plan-price">
        <span class="price-amount">{{ getPlanPrice(planName) }}</span>
      </div>
      <p class="plan-description-mobile">{{ getPlanDescription(planName) }}</p>
      
      <div class="features-section">
        <div *ngFor="let row of featureRows; trackBy: trackByRow; let i = index">
          <div *ngIf="row.feature === 'subscription.keyFeaturesInDetail' && shouldShowMobileRow(row, i, planName)" class="mobile-expandable-header" (click)="toggleMobileKeyFeatures(planName)">
            <span>{{ row.feature | translate }}</span>
            <span class="expand-icon" [class.expanded]="mobileKeyFeaturesExpanded[planName]"></span>
          </div>
          <div *ngIf="row.feature !== 'subscription.keyFeaturesInDetail' && shouldShowMobileRow(row, i, planName)" class="feature-item">
            <span class="feature-name">{{ row.feature | translate }}</span>
            <span class="feature-value" [class.available]="row[planName.toLowerCase()] === 'yes'" [class.unavailable]="row[planName.toLowerCase()] === ''">
              {{ row[planName.toLowerCase()] === 'yes' ? '✓' : (row.feature === 'subscription.features.licenses' ? (row[planName.toLowerCase()] === '3' ? ('subscription.licenses.upTo' | translate:{licenses: '3'}) : ('subscription.licenses.min' | translate:{licenses: '10'})) : getTranslatedValue(row[planName.toLowerCase()] || '')) }}
            </span>
          </div>
        </div>
      </div>
      
      <button class="subscribe-btn" (click)="subscribeToPlan(planName)">
        {{ 'subscription.startTrial' | translate }}
      </button>
    </div>
    
    <div class="currency-selector-mobile">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'subscription.currency' | translate }}</mat-label>
        <mat-select [(value)]="selectedCurrency" (selectionChange)="onCurrencyChange($event.value)">
          <mat-option *ngFor="let currency of availableCurrencies" [value]="currency">{{ currency }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div *ngIf="!isMobile">
    <div class="desktop-view">
      <table class="comparison-table">
      <tbody>
        <tr *ngFor="let row of featureRows; trackBy: trackByRow; let i = index" [style.display]="shouldShowRow(row, i) ? 'table-row' : 'none'">
          <td *ngIf="row.feature === 'subscription.keyFeaturesInDetail' && !isKeyFeaturesExpanded" 
              class="feature-cell section-header-feature" 
              [attr.colspan]="3">
            <div class="expandable-header" (click)="toggleKeyFeatures()">
              <span>{{ row.feature | translate }}</span>
              <span class="expand-icon" [class.expanded]="isKeyFeaturesExpanded"></span>
            </div>
          </td>
          
          <td *ngIf="row.feature !== 'subscription.keyFeaturesInDetail'" 
              class="feature-cell">
            <span>{{ row.feature | translate }}</span>
          </td>
          
          <ng-container *ngIf="row.feature !== 'subscription.keyFeaturesInDetail'">
            <td class="plan-cell" 
                *ngFor="let planName of ['Basic', 'Premium']" 
                [class.plan-header-cell]="i === 0">
            <div *ngIf="i === 0" class="plan-header-content">
              <div class="plan-header-row">
                <div class="plan-name">{{ planName | titlecase }}</div>
              </div>
              <div class="plan-price-container">
                <div class="plan-price">
                  <span class="price-amount">{{ getPlanPrice(planName) }}</span>
                  <span class="price-period" *ngIf="planName === 'Free'">{{ 'subscription.periods.forever' | translate }}</span>
                  <span class="price-period" *ngIf="planName !== 'Free'">{{ (isYearly ? 'subscription.periods.year' : 'subscription.periods.month') | translate }}</span>
                </div>
              </div>
              <div class="plan-description">{{ getPlanDescription(planName) }}</div>
              <button class="subscribe-btn" 
                      [class.featured-plan]="planName === 'Basic'"
                      (click)="subscribeToPlan(planName)">
                {{ 'subscription.startTrial' | translate }}
              </button>
            </div>
            <span *ngIf="i !== 0" class="feature-value" 
                  [class.available]="row[planName.toLowerCase()] === 'yes'" 
                  [class.unavailable]="row[planName.toLowerCase()] === ''">
              {{ row[planName.toLowerCase()] === 'yes' ? '✓' : (row.feature === 'subscription.features.licenses' ? (row[planName.toLowerCase()] === '3' ? ('subscription.licenses.upTo' | translate:{licenses: '3'}) : ('subscription.licenses.min' | translate:{licenses: '10'})) : getTranslatedValue(row[planName.toLowerCase()] || '')) }}
            </span>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  
  <div class="currency-selector-bottom" style="text-align: right;" *ngIf="!isMobile">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'subscription.currency' | translate }}</mat-label>
      <mat-select [(value)]="selectedCurrency" (selectionChange)="onCurrencyChange($event.value)">
        <mat-option *ngFor="let currency of availableCurrencies" [value]="currency">{{ currency }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
